import React, { useState } from 'react'
import PaginaPorDefecto from './Default'
import {
  Button,
  Table,
} from 'reactstrap'
import { FaSave, FaRegEye, FaTrash } from 'react-icons/fa'
import moment from 'moment'

import { useCargaGI } from 'hooks/useCargasGI'
import { useToggle } from 'hooks/useToggle'

import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import BuscadorTablas from 'components/Buscador/BuscadorTabla'
import { ModalCargarDatos } from 'components/ModalCargarDatos/ModalCargarDatos'

import { getFilenameFromPath } from 'utils/archivos'

export const CargarDatos = () => {
  /**
   * Estado
   */
  const [buscar, setBuscar] = useState('')
  const { open, onToggle } = useToggle()
  const [cargaSeleccionada, setCargaSeleccionada] = useState({})
  
  /**
   * Consultas
   */
  const {
    obtenerCargasGI,
    handleBuscarCargaGI,
    handleEliminarCargaGI
  } = useCargaGI(onToggle)
  const { data: cargasGi } = obtenerCargasGI('');

  /**
   * Manejadores
   */
  const onClosedModal = () => setCargaSeleccionada(null)

  return (
    <PaginaPorDefecto titulo='Cargar datos'>
      <ModalCargarDatos
        onToggle={onToggle}
        open={open}
        data={cargaSeleccionada}
        onClosedModal={onClosedModal}
      />
      <TarjetaContenido
        titulo="Cargar"
        component={
          <Button outline color='primary' onClick={onToggle}>
            <FaSave />
          </Button>
        }
      >
        <BuscadorTablas
          valor={buscar}
          onChange={setBuscar}
          onBuscar={handleBuscarCargaGI}
        />
        <Table responsive>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Grupo interes</th>
                <th>Periodo academico</th>
                <th>Nombre del archivo</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
          <tbody>
          {cargasGi?.results?.length === 0 && (
              <tr>
                <td colSpan={5}>
                  <p className='text-center'>No hay cargas registradas</p>
                </td>
              </tr>
            )}
            {cargasGi && cargasGi.results.map((carga) => {
              const handleSeleccionarCarga = () => {
                setCargaSeleccionada(carga)
                onToggle()
              }
              const handleEliminarCarga = () => handleEliminarCargaGI(carga)
              return (
                <tr key={carga.id}>
                  <td>{moment(carga.created_at).format('LLLL')}</td>
                  <td>{carga.grupo_interes__nombre}</td>
                  <td>{carga.peraca__peraca}</td>
                  <td>{getFilenameFromPath(carga.url_archivo)}</td>
                  <td>{carga.estado}</td>
                  <td className='d-flex'>
                    <Button
                      outline
                      color='primary'
                      size='sm'
                      className='mr-1'
                      onClick={handleSeleccionarCarga}
                    >
                      <FaRegEye />
                    </Button>
                    {carga.estado === 'Pendiente' && <Button
                      outline
                      color='danger'
                      size='sm'
                      onClick={handleEliminarCarga}
                    >
                      <FaTrash />
                    </Button>}
                  </td>
                </tr>
              )
            })}
          </tbody>
          </Table>
      </TarjetaContenido>

    </PaginaPorDefecto>
  )
}
